import { render } from "./createCompanyComponent.vue?vue&type=template&id=d4b1af32"
import script from "./createCompanyComponent.vue?vue&type=script&lang=js"
export * from "./createCompanyComponent.vue?vue&type=script&lang=js"

import "./createCompanyComponent.vue?vue&type=style&index=0&id=d4b1af32&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__